class PartReplacementJS {
    constructor() {
        const observer = new MutationObserver((mutations, observer) => {
            var targetElement = document.querySelector('[data-forms-id*="forms-root-"] #app-embed');
            if (targetElement) {
                // Disconnect the observer once the element is found
                observer.disconnect();
                this._applyCss(targetElement);
            }
        });
        // Observe changes in the entire document
        observer.observe(document.body, { childList: true, subtree: true });
    }

    _applyCss(targetElement) {
        const shadowRoot = targetElement.shadowRoot;
        const style = document.createElement('style');
        style.textContent = `
            ._formContainer_1q1d2_30 {
                max-width: 750px !important;
                --form-placeholder-color: #484848;
            }
            div._formDisclaimer_cit2d_38 {
                font-size: 14px !important;
                line-height: 1.5 !important;
            }
            ._formFieldContainer_1mxsl_5:has(textarea)::before {
                content: none !important;
            }
            form div > label._inputFilled_ck6wz_74,
            form div > input:focus-within ~ ._formInputFieldLabel_ck6wz_38,
            form div > textarea:focus-within ~ ._formInputFieldLabel_ck6wz_38 {
                width: auto !important;
                transform: translateY(calc(1em * -1.6)) scale(0.85) !important;
                background-color: #fff !important;
                padding: 0 5px;
            }
            form div > input, form div > .phone-country-selector button, form div > button, form div > textarea {
                --form-field-border-radius: 0;
                --form-field-border: 0 0 0 1px #636363;
                font-size: 16px !important;
                height: 48px !important;
                padding: 12px 17px !important;
                color: #636363 !important;
                box-sizing: border-box !important;
            }
            form div > textarea {
                height: auto !important;
                min-height: 100px !important;
            }
            form [type="submit"] {
                display: inline-flex !important;
                padding: 7px 30px !important;
                align-items: center !important;
                justify-content: center !important;
                height: 48px !important;
                font-size: 1rem !important;
                font-weight: 600 !important;
                letter-spacing: .02em !important;
                border: 1px solid #004767 !important;
                background: #004767 !important;
                color: #fff !important;
                border-radius: 5px !important;
                text-align: center !important;
                position: relative !important;
                z-index: 1 !important;
                overflow: hidden !important;
                -webkit-appearance: none !important;
                -moz-appearance: none !important;
                appearance: none !important;
                z-index: 0 !important;
                box-sizing: border-box !important;
                transition: color .25s 
                                cubic-bezier(.104, .204, .492, 1), background-color .25s 
                                cubic-bezier(.104, .204, .492, 1), border-color .25s 
                                cubic-bezier(.104, .204, .492, 1) !important;
            }
            form [type="submit"]:hover {
                color: #004767 !important;
            }
            form [type="submit"]:before {
                content: "";
                display: block;
                position: absolute;
                top: 0;
                bottom: 0;
                left: -5%;
                width: 125%;
                height: 100%;
                background: #fff;
                opacity: 0;
                z-index: -1;
                opacity: 1;
                border-radius: 5px;
                transform-origin: bottom left;
                backface-visibility: hidden;
                transition: all .25s cubic-bezier(.104,.204,.492,1);
                transform: rotate3d(0,0,1,6deg) translate3d(-1.2em,110%,0);
                will-change: transform;
            }
            form [type="submit"]:hover:before, form [type="submit"]:focus:before {
                transform: rotate3d(0,0,1,0) translateZ(0);
            }
        `;
        shadowRoot.querySelector("[data-form-root]").appendChild(style);
    }
}


new PartReplacementJS();